import { useQuery } from 'react-query'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getSalesTeamList } from '../api'

export const useGetSalesTeamListForFilters = () => {
  const dispatch = useAppDispatch()
  const { data, ...rest } = useQuery(
    ['filters', 'shared', 'salesTeams'],
    async () => {
      await dispatch(getSalesTeamList({}))
    },
  )
  return rest
}
